import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "card", "group", "letterLink", "empty"]

  filter() {
    const q = this.inputTarget.value.toLowerCase().trim()

    if (!q) {
      this.cardTargets.forEach(c => c.style.display = "")
      this.groupTargets.forEach(g => g.style.display = "")
      this.letterLinkTargets.forEach(l => l.style.display = "")
      this.emptyTarget.style.display = "none"
      return
    }

    let anyVisible = false
    const visibleLetters = new Set()

    this.cardTargets.forEach(card => {
      const match = card.dataset.term.includes(q)
      card.style.display = match ? "" : "none"
      if (match) {
        anyVisible = true
        visibleLetters.add(card.closest("[data-glossary-search-target='group']")?.dataset.letter)
      }
    })

    this.groupTargets.forEach(g => {
      g.style.display = visibleLetters.has(g.dataset.letter) ? "" : "none"
    })

    this.letterLinkTargets.forEach(l => {
      l.style.display = visibleLetters.has(l.dataset.letter) ? "" : "none"
    })

    this.emptyTarget.style.display = anyVisible ? "none" : ""
  }
}
